import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './TariffGroupsTableHeadRow.scss';

export const TARIFF_GROUPS_TABLE_HEADER = [
  {
    label: 'tariffGroup',
    sortBy: 'tariffGroupId'
  },
  {
    label: 'createDate',
    sortBy: 'createdAt'
  },
  {
    label: 'lastUpdate'
  },
  {
    label: 'customersCount'
  },
  {
    label: 'status'
  },
  {
    label: 'actions'
  }
];

export const TariffGroupsTableHeadRow = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {TARIFF_GROUPS_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'tariff-groups-table-head'}>
          <div className={'tariff-groups-table-head-block'}>
            <span>{i18n.getMessage(`tariffGroups.table.header.${head.label}`)}</span>
            {head.sortBy && (
              <ArrowSelect
                onClick={() => handleOnSortTable(head.sortBy)}
                className={`arrow-icon ${sortBy === head.sortBy && direction}`}
              />
            )}
          </div>
        </th>
      ))}
    </tr>
  );
};

TariffGroupsTableHeadRow.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};
